import { GroupModel } from "../models/group.model";
import { QuestionModel } from "../models/question.model";
import { QuestionTypeModel } from "../models/questionType.model";
import { SurveyModel } from "../models/survey.model";
import { BreakPointEnum } from "./constants";

//extend Navigator in global to avoid following error
//Property 'msSaveBlob' does not exist on type 'Navigator'.ts(2339)
declare global{
    interface Navigator{
        msSaveBlob:(blob: Blob,fileName:string) => boolean
    }
}

export function GetDateString(date: Date, dateWithTime: boolean) {
    date = new Date(date.toString());

    if (date && date !== null && date !== undefined) {
        var month = (+date.getMonth()+1);
        return (
            date.getFullYear() + '-' +
            appendZeroWhenLessThanTen(month) + '-' +
            appendZeroWhenLessThanTen(date.getDate()) +
            (dateWithTime
            ?
            ' ' +
            appendZeroWhenLessThanTen(date.getHours()) + ':' +
            appendZeroWhenLessThanTen(date.getMinutes()) + ':' +
            appendZeroWhenLessThanTen(date.getSeconds())
            :
            ''
            ));
    }

    return '';
}

export function appendZeroWhenLessThanTen(num: number) {
    return num < 10 ? '0' + num : num
}

export function sanatizeStringForCsv(text: string): string {

    let result = text;
    
    if (result === null || result === undefined)
        result = '';


    result = result.replace(/"/g, '""');
    if (result.search(/("|,|\n)/g) >= 0)
        result = '"' + result + '"';

    return result;
}
export function GetFileName(fileName: string | null, extension: string): string {
    const date = new Date();

    let todaysDate = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`; 

    return `${todaysDate}-raw data_${(fileName || "download")}.${extension}`;

}
export function DownloadCsv(csvData: string, linkCode: string) {
    const fileName = GetFileName(linkCode, 'csv');

    if (navigator.msSaveBlob) { // IE 10+ 
        navigator.msSaveBlob(new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' }), fileName.replace(/ /g, "_"));
    }
    else {

        var link = document.createElement('a');
        link.setAttribute('href', 'data:text/csv;charset=utf-8,\ufeff' + encodeURI(csvData));
        link.setAttribute('download', fileName.replace(/ /g, "_"));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

export function validateString(checkCondition: boolean, text: string, minLength: number, maxLength: number) {
    if (checkCondition === false)
        return true;

    if (text === null || text === undefined)
        text = '';
        
    if (text.trim().length < minLength)
        return false;

    if (maxLength >= 0 && text.trim().length > maxLength)
        return false;
    
    return true;
} 

  export function changeLangSurvey(survey: SurveyModel, lang : string): SurveyModel {
    
    const resultSurvey: SurveyModel = {...survey};

    if (lang.startsWith('f')) {
        resultSurvey.endNotes = survey.endNotesFr;
        resultSurvey.title = survey.titleFr;
        resultSurvey.startNotes = survey.startNotesFr;
    } else {
        resultSurvey.endNotes = survey.endNotesEn;
        resultSurvey.title = survey.titleEn;
        resultSurvey.startNotes = survey.startNotesEn;
    }

    resultSurvey.questions = changeLangQuestions(survey.questions, lang);
    resultSurvey.groups = changeLangGroups(survey.groups, lang);
    
    return resultSurvey;
}

export function changeLangQuestions(questions: QuestionModel[], lang : string) : QuestionModel[] {
    let resultQuestions: QuestionModel[];
    resultQuestions = [...questions];

    if (lang.startsWith('f')) {
        resultQuestions = questions.map(x => 
            {
                return {...x,
                    question: x.questionFr,
                    placeholder: x.placeholderFr,  
                    errorMessage: x.errorMessageFr,
                    mcqOptions: x.mcqOptions.map(o => {
                        return {...o,
                                option: o.optionFr
                            }
                    })
                }
            });
    } else {
        resultQuestions = questions.map(x => 
            {
                return {...x,
                    question: x.questionEn,
                    placeholder: x.placeholderEn,  
                    errorMessage: x.errorMessageEn,
                    mcqOptions: x.mcqOptions.map(o => {
                        return {...o,
                                option: o.optionEn
                            }
                    })
                }
            });
    }

    return resultQuestions;
}

export function changeLangGroups(questions: GroupModel[], lang : string) : GroupModel[] {
    let resultGroup: GroupModel[];
    resultGroup = [...questions];

    if (lang.startsWith('f')) {
        resultGroup = questions.map(x => 
            {
                return {...x,
                    groupHeading: x.groupHeadingFr,
                    groupSubHeading: x.groupSubHeadingFr
                }
            });
    } else {
        resultGroup = questions.map(x => 
            {
                return {...x,
                    groupHeading: x.groupHeadingEn,
                    groupSubHeading: x.groupSubHeadingEn
                }
            });
    }

    return resultGroup;
}

export function isRadio(minMcqOption: number, maxMcqOption: number): boolean {
    return ((maxMcqOption === 1) ||
        (minMcqOption === -1 && maxMcqOption === -1));
}

export function isValidDate(d: any) {
    d = new Date(d);
    return d instanceof Date && !isNaN(Number(d));
}

export function getQuestionTypeByCode(arrQuestionType: QuestionTypeModel[], code: string): QuestionTypeModel {

    const result = arrQuestionType.find(e => e.code === code);

    if (result)
        return result;

    return new QuestionTypeModel();

}

export function getBreakpoint(): BreakPointEnum {
    var width = window.innerWidth;

    if ( width >= 1400) return BreakPointEnum.xxl;
    if ( width >= 1200) return BreakPointEnum.xl;
    if ( width >= 992) return BreakPointEnum.lg;
    if ( width >= 768) return BreakPointEnum.md;
    if ( width >= 576) return BreakPointEnum.sm;
    //if ( width < 576) 
    return BreakPointEnum.xs;    
}

export function parseJSON(jsonString: string | null) {

    try{
        return JSON.parse(jsonString || '');
    } catch {
    }

    return {};
}
